import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import he from 'he';
import { decodeText } from 'app/utils/strings';
// import MathJax from 'mathjax3-react';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import messages from './simulatedQuestionsAlternativesMessages';

import './SimulatedQuestionsAlternatives.scss';

const alphabet = 'abcdefghifghijklmnopqrstuvxz';

function parseMedia(text) {
  console.log(process.env.REACT_APP_FILES_API);
  return text ? text.replace(/\/cp\/cpdata\/uploads/g, process.env.REACT_APP_FILES_API) : '';
}

const SimulatedQuestionsAlternativesAnswers = ({ style, ...props }) => (
  <table className="simulated-questions-alternatives" style={style}>
    <thead>
      <tr className="text-center">
        <th style={{ width: '10%' }}>#</th>
        <th>
          <FormattedMessage {...messages.answers} />
        </th>
      </tr>
    </thead>
    <tbody>
      {props.alternatives &&
        props.alternatives.map((alternative, alternativeIndex) => (
          <tr className={classNames({ correct: Number(alternative.correct) })}>
            <td className="text-center">{alphabet.charAt(alternativeIndex).toUpperCase()}</td>
            {/* <td
            className="text-center"
            dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(alternative.text)) }}
          /> */}
            <td className="text-center">
              <MathJaxContext>
                <MathJax>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: parseMedia(decodeText(alternative.text)),
                    }}
                  />
                </MathJax>
              </MathJaxContext>
            </td>
          </tr>
        ))}
    </tbody>
  </table>
);

SimulatedQuestionsAlternativesAnswers.propTypes = {};

export default SimulatedQuestionsAlternativesAnswers;
